var _defs, _path, _path2, _path3, _line, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdsealLockupA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "la-icon",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#615DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3DD9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "la-text",
    x1: 48,
    y1: 0,
    x2: 168,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#615DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3DD9EB"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3L34 9V21C34 29 27 35.5 20 37.5C13 35.5 6 29 6 21V9Z",
    fill: "url(#la-icon)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7L30 12V21C30 27 25 32 20 33.5",
    stroke: "white",
    strokeWidth: 0.8,
    opacity: 0.25,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.5L17.5 25L27 14.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 10,
    x2: 46,
    y2: 30,
    stroke: "#615DFF",
    strokeWidth: 1,
    opacity: 0.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 27,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontWeight: 700,
    fontSize: 22,
    letterSpacing: -0.5,
    fill: "url(#la-text)"
  }, "Prodseal")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdsealLockupA);
export default __webpack_public_path__ + "static/media/prodseal-lockup-a.5b4388c225a760ccc392d28c820fefaf.svg";
export { ForwardRef as ReactComponent };